module.exports = __webpack_public_path__ + "static/img/cabecera.4d8de50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/medio-ambiente/cabecera.jpg
// module id = zsly
// module chunks = 0